<template>
  <div class="rt-lookup" style="display:block;">

    <!-- <el-tooltip placement="top" :content="lookupValue.name" :open-delay="100"
        :disabled="lookupValue.name ? false : true"> -->
    <el-tooltip placement="left" :append-to-body="canJump" :content="'点击可跳转'" :open-delay="100">
      <!-- <span> -->
      <div @click="goEntityDetail" v-if="canJump && disabled" class="el-input is-disabled el-input__inner disabled_input">{{ lookupValue.name }}</div>
      <el-input v-else readonly ref="input" :disabled="disabled"  v-model="lookupValue.name">
        <i slot="suffix" v-if="!disabled" style="z-index:999" class="el-input__icon el-icon-search"
          @click.stop="showLookupDialog"></i>
      </el-input>
      <!-- </span> -->
    </el-tooltip>
    <!-- </el-tooltip> -->

    <rt-lookup-dialog ref="lookupDialog" :entity="entity" :request-url="dialogRequestUrl" :name-field="nameField"
      :id-field="idField" :display-fields="dialogDisplayFields" :orderby-fields="dialogOrderbyFields"
      :custom-conditions="dialogCustomConditions" :filter-fields="dialogFilterFields" :return-fields="dialogReturnFields"
      :dialog-extra-fields="dialogExtraFields" @data-selected="handleDataSelected">
    </rt-lookup-dialog>
  </div>
</template>

<script>
import RtLookupDialog from "./lookup-dialog";

export default {
  name: "RtLookup",
  props: {
    value: {
      type: Object,
      required: false,
    },
    disabled: Boolean,
    // isShowTooltip: {
    //   type: Boolean,
    //   required: true,
    // },
    entity: {
      type: String,
      required: true,
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String,
    dialogReturnFields: String,
    dialogExtraFields: Array,
    placeholder: String,
    canJump: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  components: {
    "rt-lookup-dialog": RtLookupDialog,
  },
  computed: {},
  data() {
    return {
      isShowTooltip: false,
      lookupValue: {},
      // str1: "a:123;b:234;c456",
      // str: "",
    };
  },
  watch: {
    value(newValue) {
      this.lookupValue = newValue || {};
    },
  },
  mounted() {
    // var reg = /[;]/g;
    // this.str = this.str1.replace(reg, "$&<br/>");
    // console.log(str);
    if (this.value) {
      this.lookupValue = this.value;
    }
  },
  methods: {
    goEntityDetail() {
      if (!this.canJump) return
      if (this.lookupValue && this.lookupValue.id) {
        //   let params = {
        //     entityName: this.entity,
        //     entityId: this.lookupValue.id,
        //   };
        //   console.log("params", params);
        //   this.$emit("goEntityDetail", params);
        // this.$router.push({
        //   name: this.entity + "-edit",
        //   params: {
        //     id: this.lookupValue.id,
        //   },
        // });
        this.$router.push({
          path: "/" + `${this.entity}/edit/${this.lookupValue.id}`,
        });
        // this.$router.push({ path: "/" + `${this.entity}/edit` }); //ȡ���õ�ַ
      }
    },
    showLookupDialog() {
      if (this.disabled) {
        return;
      }

      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);

      this.$emit("change", val);
    },
  },
};
</script>

<style scoped>
.disabled_input{
  width: 100%;
  background-color: #f1f2f4;
  color: #0b0c0e !important;
}
.rt-lookup:hover {
  border: none;
}
</style>



// WEBPACK FOOTER //
// lookup.vue?3b2775b2